import getConfig from "next/config";
import WarrantyRibbon from "@components/Icons/WarrantyRibbon";
import { formatPrice } from "@lib/helpers";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const ProductGreenTax = ({ data }) => (
  <div className="Warranty-info flex justify-start items-center u-border-dotted">
    <div className="Warranty-icon mr-1 w-4 h-4">
      <WarrantyRibbon fill="#319D10" />
    </div>
    <div
      className="Warranty-info text-black"
      style={{ fontSize: "12px", lineHeight: "14px" }}
    >
      <span className="Warranty-label">Include taxa verde</span>
      {": "}
      <span className="Warranty-qty font-bold">
        {formatPrice(data)} {settings.currency}
      </span>
    </div>
  </div>
);

export default ProductGreenTax;
